export default () => ({
    loaderStatus: false
})